import PropTypes from "prop-types"
import classnames from "classnames"
import { IconButton } from "@mui/material"
import { formatLongDate } from "helpers/formatters/dates"
import DailyDetails from "./components/daily-details"
import ContributorsDetails from "modules/historical-exposure-contributors"
import { METRIC_TYPES_SHAPE } from "helpers/metrics/shapes"
import "./style.scss"

function AnalyzeExposureDetails({
  selectedDate,
  selected,
  selectedValue,
  details,
  viewType,
  displayType,
  displayTypeName,
  order,
  show,
  hide,
  sort,
  drift,
  openFactorProfile,
  openSecurityProfile,
  toggleLitmusView,
  contributorsGrouping,
  setContributorsGrouping,
  showGroup,
  hideGroup,
  selectedGroup,
  selectedOption,
  contentSetId,
  groupSort,
  groupOrder,
  toggleShowNotHeld,
  selectedViews,
  metricType,
  formatter,
  dailyDetailsFormatter,
  currencyScale,
  currency,
}) {
  const rightOptions = displayType === "style" || displayType === "coremacro" || displayType === "esg" || contentSetId
    ? <IconButton
        onClick={toggleLitmusView}
        color="default"
        className="fa fa-expand daily-exposure-switcher-button"
        size="large"
    />
    : undefined

  return <div className={classnames("modules_analyze-exposure-details")}>
    <h4 className="header"><span>As of {formatLongDate(selectedDate)}</span>{rightOptions}</h4>
    {!selected
      ? <DailyDetails {...{
          drift,
          viewType,
          openFactorProfile: contentSetId ? null : openFactorProfile,
          displayTypeName,
          data: details,
          factorTable: displayType !== "total" && displayType !== "factors",
          show,
          groupSort,
          groupOrder,
          formatter: dailyDetailsFormatter,
          currencyScale,
          currency,
        }}
      />
      : <ContributorsDetails {...{
          viewType,
          openSecurityProfile,
          openFactorProfile,
          showGroup,
          hideGroup,
          selectedGroup,
          hide,
          sort,
          order,
          selected,
          selectedValue,
          selectedDate,
          setContributorsGrouping,
          contributorsGrouping,
          selectedOption,
          contentSetId,
          toggleShowNotHeld,
          details,
          show,
          groupOrder,
          selectedViews,
          metricType,
          formatter,
          currency,
        }}
      />}
  </div>
}

AnalyzeExposureDetails.propTypes = {
  selectedDate: PropTypes.string,
  selected: PropTypes.object,
  selectedValue: PropTypes.number,
  details: PropTypes.array,
  viewType: PropTypes.string,
  displayType: PropTypes.string,
  order: PropTypes.object,
  show: PropTypes.func,
  hide: PropTypes.func,
  sort: PropTypes.func,
  toggleLitmusView: PropTypes.func,
  drift: PropTypes.object,
  openFactorProfile: PropTypes.func,
  openSecurityProfile: PropTypes.func,
  contributorsGrouping: PropTypes.object,
  setContributorsGrouping: PropTypes.func.isRequired,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  selectedOption: PropTypes.object.isRequired,
  contentSetId: PropTypes.string,
  displayTypeName: PropTypes.string.isRequired,
  filtersVisible: PropTypes.bool.isRequired,
  groupSort: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  toggleShowNotHeld: PropTypes.func.isRequired,
  selectedViews: PropTypes.array,
  formatter: PropTypes.func,
  dailyDetailsFormatter: PropTypes.func,
  currencyScale: PropTypes.string,
  currency: PropTypes.string,
  metricType: METRIC_TYPES_SHAPE.isRequired,
}

export default AnalyzeExposureDetails
